/**
 * Fetches the event bucket configuration from the specified URL and caches it for future use.
 *
 * This function checks if the configuration is already fetched and stored in a variable.
 * If it is, the cached configuration is returned immediately. Otherwise, it fetches the
 * configuration from the provided URL and stores it for future access.
 *
 * @param {string} eventBucketUrl - The URL of the event bucket to fetch the configuration from.
 * @returns {EventBucketConfig|null} A promise that resolves to the event bucket configuration object, or null if an error occurs.
 * @throws {Error} Throws an error if the fetch operation fails.
 *
 * @example
 * const config = await fetchEventBucketConfig('https://api.eventive.org/event_buckets/your-event-bucket-id');
 * console.log('Event Bucket Config:', config);
 */

let eventBucketConfig;
export async function fetchEventBucketConfig(eventBucketUrl) {
  if (eventBucketConfig) {
    return eventBucketConfig;
  }

  try {
    const response = await fetch(`${eventBucketUrl}/config.json`, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Check if the response is ok
    if (!response.ok) {
      console.error(`HTTP error! Status: ${response.status}`);
      return null;
    }

    // Die Konfiguration abrufen und speichern
    eventBucketConfig = await response.json();
    return eventBucketConfig;
  } catch (error) {
    console.error('Error fetching config.json:', error);
    throw error;
  }
}

